import { apiClient } from './client';

// Smart search (header). A source answers within 2 s or the panel says it was slow — never retried.
export const SOURCE_TIMEOUT_MS = 2000;
const NO_RETRY = { __retryAttempt: 99 };

export const getSearchSources = () => apiClient.get('/smart-search/sources').then((r) => r.data);
export const searchSource = (key, q, signal) => apiClient
  .get(`/smart-search/sources/${key}`, { params: { q }, signal, timeout: SOURCE_TIMEOUT_MS, ...NO_RETRY })
  .then((r) => r.data);
export const getRecentActivity = () => apiClient.get('/smart-search/recents').then((r) => r.data.recents || []);
export const clearRecentActivity = () => apiClient.delete('/smart-search/recents');
export const recordOpened = (type, id) => apiClient.post('/smart-search/recents', { type, id });
